define(
    'SuiteDynamics.DescriptionImage.EntryPoint',
    [
        'SuiteDynamics.DescriptionImage.View',
        'SuiteDynamics.DescriptionImage.SS2Model',
        'Facets.Browse.View',
        'underscore'
    ],
    function (
        DescriptionImageView,
        DescriptionImageModel,
        FacetsBrowseView,
        _
    ) {
        'use strict';

        return {
            mountToApp: function (container) {

                var plp = container.getComponent('PLP');
                if (!plp) return;

                var customSubtitleData = '';

                plp.on('beforeShowContent', function () {

                    var model = new DescriptionImageModel();
                    var dfd = jQuery.Deferred();

                    var categoryInfo = plp.getCategoryInfo();
                    var currentCategoryId =
                        categoryInfo && categoryInfo.internalid;

                    if (!currentCategoryId) {
                        dfd.resolve();
                        return dfd;
                    }

                    model.fetch({
                        data: {
                            categoryid: currentCategoryId
                        }
                    }).done(function (data) {

                        customSubtitleData =
                            data.customSubtitle || '';

                    }).always(function () {
                        dfd.resolve();
                    });

                    return dfd;
                });

                _.extend(FacetsBrowseView.prototype, {

                    getContext: _.wrap(
                        FacetsBrowseView.prototype.getContext,
                        function (fn) {

                            var context =
                                fn.apply(this, _.toArray(arguments).slice(1));

                            context.customSubtitle =
                                customSubtitleData || '';

                            context.hasCustomSubtitle =
                                !!customSubtitleData;

                            return context;
                        }
                    )
                });

                plp.addChildView(
                    'Facets.Browse.CategoryBottom',
                    function () {
                        return new DescriptionImageView({
                            plp: plp
                        });
                    }
                );
            }
        };
    }
);

